export const isObjectEmpty = (objectInQuestion) => {
    if (typeof objectInQuestion === 'object' &&
        objectInQuestion !== null &&
        !Array.isArray(objectInQuestion)) {
        return Object.keys(objectInQuestion).length === 0;
    }
};
export const waitForProperty = (predicate) => {
    return new Promise((resolve) => {
        const check = () => {
            // console.log('checking', predicate());
            if (!predicate())
                return;
            clearInterval(interval);
            resolve(true);
        };
        const interval = setInterval(check, 100);
        check();
    });
};
export const waitFor = (predicate, timeout) => {
    return new Promise((resolve) => {
        let running = true;
        const check = async () => {
            const res = await predicate();
            if (res) {
                running = false;
                resolve(res);
            }
            if (running)
                setTimeout(check, 100);
        };
        check();
        if (timeout) {
            setTimeout(() => {
                running = false;
                resolve(false);
            }, timeout);
        }
    });
};
